export const REACTIONS = [{
        viewValue: 'Like',
        value: 1,
        icon: '#like',
        iconClass: 'text-primary'
    }, {
        viewValue: 'Love',
        value: 2,
        icon: '#heart',
        iconClass: 'text-danger'
    }, {
        viewValue: 'Celebrate',
        value: 3,
        icon: '#confetti',
        iconClass: 'text-primary'
    }, {
        viewValue: 'Question',
        value: 4,
        icon: '#information',
        iconClass: 'text-primary'
    } ,{
        viewValue: 'Insightful',
        value: 5,
        icon: '#insight',
        iconClass: 'text-primary'
    }, {
        viewValue: 'Disapprove',
        value: 6,
        icon: '#dislike',
        iconClass: 'text-danger'
    }, {
        viewValue: 'Care',
        value: 7,
        icon: '#hug',
        iconClass: 'text-primary'
    }, {
        viewValue: 'Sad',
        value: 8,
        icon: '#sad',
        iconClass: 'text-warning'
    }, {
        viewValue: 'Angry',
        value: 9,
        icon: '#angry',
        iconClass: 'text-danger'
    }, {
        viewValue: 'Haha',
        value: 10,
        icon: '#laugh',
        iconClass: 'text-primary'
    }, {
        viewValue: 'Wow',
        value: 11,
        icon: '#surprised-emoticon-square-face-with-open-eyes-and-mouth',
        iconClass: 'text-success'
    }
];